import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Projects } from "./components/projects";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";

import EngineeringSolutions from "./pages/EngineeringSolutions";
import NotFound from "./pages/NotFound";
import BlogsPage from "./pages/BlogsPage";
import BlogPostPage from "./pages/BlogPostPage";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ElectricalServicePage from "./pages/ElectricalEngineeringSolutions";
import FacilityMaintainServicePage from "./pages/FacilityMaintainSolutions";
import CustomersGrid from "./components/customers";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
      <Routes>

        {/* Home Page */}
        <Route
          path="/"
          element={
            <div>
              <Navigation />
              <Header data={landingPageData.Header} />
              <Features data={landingPageData.Features} />
              <About data={landingPageData.About} />
              <Services data={landingPageData.Services} />
              {/* <Gallery data={landingPageData.Gallery} /> */}
              <Projects />
              <Testimonials data={landingPageData.Testimonials} />
              <CustomersGrid />
              <Contact data={landingPageData.Contact} />
            </div>
          }
        />

        {/* Engineering Solutions (Duplicate Page) */}
        <Route path="/engineering-solutions" element={<EngineeringSolutions />} />
        <Route path="/electrical-engineering-solutions" element={<ElectricalServicePage />} />
        <Route path="/facility-maintenance-solutions" element={<FacilityMaintainServicePage />} />
        
        {/* Blog Pages */}
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:id" element={<BlogPostPage />} />
        
        {/* 404 Page - Catch all undefined routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
